import { imprimirCheckListColaboradorPuro } from 'modulo-gerencial-erp-pacotes-impressora-termica';

import { imprimirServicoNovo, buscarDadosImpressao } from '../utils';

async function imprimir(id, query = '', usar_nova_impressao = false) {
  /* if (!usar_nova_impressao) {
    return await imprimirServicoAntigo(id, 10, query);
  }

  const dados = await buscarDadosImpressao(id, 10);

  const { comandos } = layout(adapter(dados));

  const response = await imprimirServicoNovo(
    id,
    'checklist-colaborador-puro',
    comandos,
  );
  return response.data; */
  /* return await imprimirNotaPreVenda({
    id,
    buscarDadosImpressao,
    chamarServicoImpressoraTermica: imprimirServicoNovo,
    query: '',
  }); */

  return await imprimirCheckListColaboradorPuro({
    id,
    buscarDadosImpressao,
    chamarServicoImpressoraTermica: imprimirServicoNovo,
    query,
  });
}

export default imprimir;
